let debounceTimeout: number | undefined = undefined;

export const debounce = async (callback: () => Promise<void>, ms = 0) => {
  clearTimeout(debounceTimeout);

  await new Promise((resolve) => {
    debounceTimeout = window.setTimeout(async () => resolve(callback()), ms);
  });
};
